function hideBuyNowForNoStock () {
  if (window.theme.settings.template !== 'product.supadu') return
  const buyNowButton = document.querySelector('.shopify-payment-button')
  if (!buyNowButton) return
  const item = window.theme.productData
  if (!item) return
  if (!item.available) buyNowButton.remove()
}

function customFunctions () {
  hideBuyNowForNoStock()
}

module.exports = { customFunctions }
